import { Card, Table, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { formatDateTime } from '../format';
import { useZenAuditLog, useZenBootstrap } from '../hooks';
import { EmptyState, OrderNumber, TableSkeleton } from '../ui';

const { Text } = Typography;

export function AuditPage() {
  const { data, isLoading } = useZenAuditLog();
  const { data: bootstrap } = useZenBootstrap();
  const orderNumbers = new Map(bootstrap?.workOrders.map((order) => [order.id, order.orderNumber]) ?? []);
  return (
    <Card styles={{ body: { padding: 0 } }}>
      {isLoading ? <TableSkeleton /> : (
        <Table
          className="zen-responsive-table"
          rowKey="id"
          size="small"
          dataSource={data ?? []}
          scroll={{ x: 'max-content' }}
          pagination={{ pageSize: 30, responsive: true, showSizeChanger: false }}
          locale={{ emptyText: <EmptyState compact title="No activity yet" description="Order changes, sign-ins and administration changes are recorded here." /> }}
          columns={[
            { title: 'Time', dataIndex: 'createdAt', width: 190, render: (value: string) => formatDateTime(value) },
            { title: 'Person', dataIndex: 'actorName', width: 180 },
            { title: 'Action', dataIndex: 'action' },
            {
              title: 'Work order',
              dataIndex: 'workOrderId',
              width: 180,
              render: (value?: string) => value
                ? <Link to={`/work-orders/${value}`}><OrderNumber>{orderNumbers.get(value) ?? value}</OrderNumber></Link>
                : <Text type="secondary">—</Text>,
            },
          ]}
        />
      )}
    </Card>
  );
}
